import FixedCapacitorBanks from "../classes/FixedCapacitorBank"

export const fixedCapacitorBanks = [
  new FixedCapacitorBanks({alias:"acometida", svgSrc: "/symbol-assets/Acometida.svg", label: "Label for Type 1"}),
  new FixedCapacitorBanks({alias:"arco", svgSrc: "/symbol-assets/Arco.svg", label: "Label for Type 2"}),
  new FixedCapacitorBanks({alias:"condensador", svgSrc: "/symbol-assets/Condensador.svg", label: "Label for Type 3"}),
];
